import {useFetchLecturers} from "./Hooks/useFetchLecturers";
import block from "bem-css-modules";
import ProgressBar from "./Components/ProgressBar/ProgressBar";

import s from './App.module.scss';
import Lecturer from "./Components/Lecturers/Lecturer";

const b = block(s);
const App = () => {
    const {loading, lecturers} = useFetchLecturers();

    if (loading) {
        return <div className={b()}><ProgressBar size={90}/></div>
    }

    return (<div className="container text-center">
            {lecturers.map((lecturer, index) => (<Lecturer key={index} lecturer={lecturer} index={index} />))}
        </div>
    );
};

export default App;
